export type ExpiryStatus = 'expired' | 'expiring_soon' | 'ok' | 'no_date';

export function expiryTagColor(status?: ExpiryStatus | string | null): string {
  if (status === 'expired') return 'red';
  if (status === 'expiring_soon') return 'orange';
  if (status === 'ok') return 'green';
  return 'default';
}

export function formatShelfDate(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(`${value}T00:00:00`);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
}
